import { useGtm } from '@gtm-support/vue-gtm';
import { onCLS, onFID, onLCP, onINP, Metric } from 'web-vitals';
import { useUiStore } from '@/stores';

export default defineNuxtPlugin(() => {
  const {
    public: { isDev },
  } = useRuntimeConfig();
  const { addWebVital } = useUiStore();

  const sendToGTM = (event: Metric) => {
    const gtm = useGtm();
    // Assumes the global `dataLayer` array exists, see:
    // https://developers.google.com/tag-manager/devguide
    gtm?.trackEvent({
      event: 'web-vitals',
      event_category: 'Web Vitals',
      event_action: event.name,
      // Google Analytics metrics must be integers, so the value is rounded.
      // For CLS the value is first multiplied by 1000 for greater precision
      // (note: increase the multiplier for greater precision if needed).
      event_value: Math.round(event.name === 'CLS' ? event.delta * 1000 : event.delta),
      // The `id` value will be unique to the current page load. When sending
      // multiple values from the same page (e.g. for CLS), Google Analytics can
      // compute a total by grouping on this ID (note: requires `eventLabel` to
      // be a dimension in your report).
      event_label: event.id,
    });

    if (isDev) {
      addWebVital({ ...event });
    }
  };

  onCLS(sendToGTM);
  onFID(sendToGTM);
  onLCP(sendToGTM);
  onINP(sendToGTM);
});
